import { doc, getDoc, serverTimestamp, setDoc, updateDoc } from 'firebase/firestore'
import { db } from '@/firebase'

const DOC_REF = doc(db, 'settings', 'voucherProgram')

const DEFAULT_PROGRAM = {
  enabled: true,
  spendThreshold: 900, // R900 spend earns a voucher
  rewardType: 'amount', // legacy: 'amount' (Rand value)
  rewardKind: 'amount', // 'amount' | 'service'
  rewardAmount: 100, // R100 voucher value (when rewardType = 'amount')
  rewardLabel: 'Voucher',
  // When rewardKind = 'service', this defines the free wash tier.
  rewardCatalogServiceId: null,
  rewardCatalogTierId: null,
  carryOverRemainder: true,
  updatedAt: serverTimestamp(),
  createdAt: serverTimestamp(),
}

export const voucherProgramService = {
  async get() {
    const snap = await getDoc(DOC_REF)
    if (snap.exists()) return { id: snap.id, ...snap.data() }

    await setDoc(DOC_REF, DEFAULT_PROGRAM)
    return { id: 'voucherProgram', ...DEFAULT_PROGRAM }
  },

  async update(patch) {
    await updateDoc(DOC_REF, { ...patch, updatedAt: serverTimestamp() })
  },
}

